import { createContext, type PropsWithChildren, useContext, useState } from "react"
import { CompanyRestrictionModal } from "../../components/CompanyRestrictionModal"
import { useEvent } from "@oysterhr/common"
import { useCompanyRestrictionsQuery } from "./hooks/useCompanyRestrictionsQuery"

type ContextType = {
  openRestrictionsModal: (companyId: string) => void
}

const CompanyRestrictionContext = createContext<ContextType>({} as ContextType)

const CompanyRestrictionProvider = ({ children }: PropsWithChildren) => {
  const [companyId, setCompanyId] = useState<string>("")
  const { data } = useCompanyRestrictionsQuery({ companyId })
  const closeRestrictionsModalOpen = useEvent(() => setCompanyId(""))
  const company = data?.company?.customer

  return (
    <CompanyRestrictionContext.Provider
      value={{
        openRestrictionsModal: setCompanyId,
      }}
    >
      {children}
      {company && (
        <CompanyRestrictionModal onClose={closeRestrictionsModalOpen} company={company} />
      )}
    </CompanyRestrictionContext.Provider>
  )
}

export const useCompanyRestrictionContext = () => {
  const context = useContext(CompanyRestrictionContext)

  if (!context) {
    throw new Error("useCompanyRestrictionContext must be used within a CompanyRestrictionProvider")
  }

  return context
}

export { CompanyRestrictionContext, CompanyRestrictionProvider }
